import React, { FC, memo, useMemo } from 'react'
import Link from 'next/link'
import { PromoBlock } from '@ucheba/ui/components/PromoBlock/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { List, ListItem } from '@ucheba/ui/components/List/desktop'
import CheckCircleIcon from '@ucheba/ui/icons/icon__check_circle-outline.svg'
import { IConsultationPromoProps } from '../types'
import data from '../data.json'

/** Промо консультаций */
const ConsultationPromo: FC<IConsultationPromoProps> = (props) => {
  const { orientation, ...otherProps } = props
  const { title, buttonText, buttonHref, list } = data

  const isVertical = useMemo(() => orientation === 'vertical', [orientation])

  return (
    <PromoBlock
      color='navy'
      imgView='consultationBoy'
      spacing={isVertical ? ['small', 'medium'] : ['large', 'xlarge']}
      orientation={orientation}
      {...otherProps}
    >
      <Heading h3={title} />

      <List color='white'>
        {list.map((text, index) => (
          <ListItem
            alignItems='flex-start'
            key={index}
            StartIcon={<CheckCircleIcon width='20px' height='20px' />}
          >
            {text}
          </ListItem>
        ))}
      </List>

      <Spacing spacing='large' />

      <Link href={buttonHref} legacyBehavior>
        <Button block={isVertical} color='gold' href={buttonHref}>
          {buttonText}
        </Button>
      </Link>
    </PromoBlock>
  )
}

export { ConsultationPromo }
export default memo(ConsultationPromo)
